var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 14V11.6667H7.2V3.88889H5.6V6.22222H0V0H5.6V2.33333H10.4V0H16V6.22222H10.4V3.88889H8.8V10.1111H10.4V7.77778H16V14H10.4ZM12 4.66667H14.4V1.55556H12V4.66667ZM12 12.4444H14.4V9.33333H12V12.4444ZM1.6 4.66667H4V1.55556H1.6V4.66667Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/workflow.f76c90aa048763d1f4cc81fd7a4b0715.svg";
export { ForwardRef as ReactComponent };